import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import AboutUs from "@/components/AboutUs";
import OurValues from "@/components/OurValues";
import OurTeam from "@/components/OurTeam";
import Strategies from "@/components/Strategies";
import Insights from "@/components/Insights";
import MediaCoverage from "@/components/MediaCoverage";
import ContactUs from "@/components/ContactUs";
import Footer from "@/components/Footer";
import TermsOfUsePage from "@/pages/TermsOfUsePage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import { Toaster } from "@/components/ui/sonner";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <AboutUs />
        <OurValues />
        <OurTeam />
        <Strategies />
        <Insights />
        <MediaCoverage />
        <ContactUs />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
